module.exports = __webpack_public_path__ + "static/img/GPTW-2019.62f90a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/GPTW-2019.png
// module id = Rnde
// module chunks = 0